import { useCallback, useEffect, useRef, useState } from 'react';

export interface CopyHashState {
  copiedHashReportId: string | null;
  handleCopyHash: (hash: string, reportId: string) => Promise<void>;
}

export function useCopyHash(): CopyHashState {
  const [copiedHashReportId, setCopiedHashReportId] = useState<string | null>(null);
  const copyResetTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleCopyHash = useCallback(async (hash: string, reportId: string) => {
    try {
      await navigator.clipboard.writeText(hash);
      setCopiedHashReportId(reportId);
      if (copyResetTimeoutRef.current) {
        clearTimeout(copyResetTimeoutRef.current);
      }
      copyResetTimeoutRef.current = setTimeout(() => {
        setCopiedHashReportId(null);
        copyResetTimeoutRef.current = null;
      }, 3000);
    } catch (error) {
      // eslint-disable-next-line no-console -- intentional error logging
      console.error('Failed to copy hash:', error);
    }
  }, []);

  useEffect(
    () => () => {
      if (copyResetTimeoutRef.current) {
        clearTimeout(copyResetTimeoutRef.current);
      }
    },
    [],
  );

  return { copiedHashReportId, handleCopyHash };
}
